import { formatFileSize, shortenFileName } from "@vixi/utils";
import { ComponentProps, FC, forwardRef } from "react";

// Assets
import DeleteIcon from "@assets/icons/delete.svg?react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/base/button";

const FileItemRoot = forwardRef<HTMLDivElement, ComponentProps<"div">>((props, ref) => (
  <div
    {...props}
    className={cn(
      "bg-paper border-primary-light flex w-full items-center rounded border-2 py-2.5 ps-6 pe-4",
    )}
    ref={ref}
  />
));

interface FileItemProps {
  file: File;
  onDelete?: () => void;
}

export const FileItem: FC<FileItemProps> = ({ file, onDelete }) => {
  return (
    <FileItemRoot>
      <p>{shortenFileName(file.name)}</p>
      <p dir="ltr" className="mx-4 mt-1">
        {formatFileSize(file.size)}
      </p>
      <Button size="icon" className="ms-auto size-7 p-1.5" onClick={onDelete}>
        <DeleteIcon className="h-full w-full" />
      </Button>
    </FileItemRoot>
  );
};
